var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"escalon-absolute-center",attrs:{"src":require("../../assets/INF.png"),"title":"Image Not Found"}})}
var staticRenderFns = []

export { render, staticRenderFns }